import { useActiveUserContext, useAuthServiceContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

/**
 * Hook providing user role helpers.
 * Returns an object so additional helpers can be added later.
 */
export const useUserRoles = () => {
    const { user: activeUser, hasPermission } = useActiveUserContext();
    const { updateProfile, updatePassword, logout } = useAuthServiceContext();

    const getUserRoleName = () => {
        if (!activeUser) return '';
        const userName = activeUser.displayName.toUpperCase();
        // TODO PERMFE -change this+
        if (hasPermission(PermissionsEnum.UseAdmConsoleAdv)) return `${userName}  (Op Admin)`;
        if (hasPermission(PermissionsEnum.DrActAdv)) return `${userName} (Vivli Admin)`;

        return userName;
    };

    const getCommands = () => {
        {
            const commandLinks = [
                {
                    title: 'Edit Profile',
                    link: '/',
                    command: () => updateProfile(),
                    separateGroup: true,
                    component: null,
                    url: '',
                    index: 0
                },
                {
                    title: 'Change Password',
                    link: '/',
                    command: () => updatePassword(),
                    component: null,
                    url: '',
                    index: 1
                },
                {
                    title: 'Log Out',
                    link: '/',
                    count: 0,
                    url: null,
                    separateGroup: true,
                    component: null,
                    command: () => logout(),
                    finalCommand: true
                }
            ];
            return commandLinks;
        }
    };

    return {
        getUserRoleName,
        getCommands
    };
};
